import { defineComponent, ref, watch } from '@vue/composition-api';
import { commonVideoAttr } from '@/utils/dom';
export default defineComponent({
  components: {},
  props: {
    play: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: true
    },
    poster: {
      type: String,
      default: ''
    }
  },
  emits: ['click'],
  setup: function setup(props, ctx) {
    var videoRef = ref(null);
    var sourceReady = ref(false);
    watch(function () {
      return videoRef.value;
    }, function (newVal) {
      if (newVal) {
        newVal.addEventListener('canplay', function () {
          sourceReady.value = true;
        });
      }
    });
    var timer;

    var handlePlay = function handlePlay(val) {
      if (timer) {
        clearTimeout(timer);
      }

      if (val) {
        timer = setTimeout(function () {
          var _videoRef$value;

          (_videoRef$value = videoRef.value) === null || _videoRef$value === void 0 ? void 0 : _videoRef$value.play();
        }, 500);
      } else {
        var _videoRef$value2;

        (_videoRef$value2 = videoRef.value) === null || _videoRef$value2 === void 0 ? void 0 : _videoRef$value2.pause();
      }
    };

    watch(function () {
      return props.play;
    }, function () {
      handlePlay(props.play);
    });
    return {
      commonVideoAttr: commonVideoAttr,
      sourceReady: sourceReady,
      videoRef: videoRef
    };
  }
});